<div class="default-dialog-header font-weight-normal">
	<h2 mat-dialog-title>
		<span fxFlex>Edit Lane</span>
	</h2>
</div>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content">
	<div class="p-8" fxLayout="column" fxLayoutGap="1rem">
		<div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="start center">
			<div class="fw-700" fxFlex="15">Origin:</div>
			<mat-form-field fxFlex="45">
				<input
					[(ngModel)]="originCity"
					autocomplete="off"
					matInput
					placeholder="City"
				/>
			</mat-form-field>
			<mat-form-field fxFlex="30">
				<input
					[(ngModel)]="originState"
					autocomplete="off"
					matInput
					placeholder="State"
				/>
			</mat-form-field>
		</div>

		<div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="start center">
			<div class="fw-700" fxFlex="15">Destination:</div>
			<mat-form-field fxFlex="45">
				<input
					[(ngModel)]="destCity"
					autocomplete="off"
					matInput
					placeholder="City"
				/>
			</mat-form-field>
			<mat-form-field fxFlex="30">
				<input
					[(ngModel)]="destState"
					autocomplete="off"
					matInput
					placeholder="State"
				/>
			</mat-form-field>
		</div>

		<div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="start center">
			<div class="fw-700" fxFlex="15">Equipment:</div>
			<mat-form-field fxFlex="75">
				<mat-select
					[(ngModel)]="equipmentTypes"
					[compareWith]="compareEquipment"
					multiple
					placeholder="Select Equipment"
				>
					<mat-option *ngFor="let trailer of trailerTypes" [value]="trailer.dbVal">
						{{ trailer.value }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</div>
</mat-dialog-content>
<mat-divider></mat-divider>

<mat-dialog-actions class="default-dialog-action">
	<div fxFlex="100" fxLayoutAlign="end center" fxLayoutGap="1rem">
		<a (click)="cancel()">
			<span class="primary-text text-underline cursor-pointer">Cancel</span>
		</a>
		<button
			(click)="save()"
			color="primary"
			mat-raised-button
		>
			Confirm
		</button>
	</div>
</mat-dialog-actions>
